import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { PensionContext, PensionParameters } from '../../../contexts/pension-robot/PensionContext';
import { isPensionCalculatedTogether } from '../../../utils/functions';
import { CurrencyFormGroup } from '../../general/form-inputs/CurrencyFormGroup';
import { CocktailWrapperScreen } from './CocktailWrapperScreen';
import { SavingButtons } from './DialogueDataSaving/PensionProgressSaver';
import { BackButton, NextButton } from './NavigationButtons';

export const PensionGrossSection: React.FC<{ isPartnerSection?: boolean }> = ({ isPartnerSection = false }) => {
    const { t } = useTranslation('pension');
    const {
        parameters: { pensionInfo, personalInfo },
        actions,
    } = useContext(PensionContext);

    const withPartner = isPensionCalculatedTogether(personalInfo);

    const getNextPage = () => {
        if (withPartner){
            if (isPartnerSection)
                return "supplement";
            return "pension-partner";
        }
        return "supplement";
    }

    return (
        <CocktailWrapperScreen
            page={3}
            title={
                isPartnerSection
                    ? t('pension-cocktail-fill-screen-gross-title-partner')
                    : t('pension-cocktail-fill-screen-gross-title')
            }
            subTitle={
                isPartnerSection
                    ? t('pension-cocktail-fill-screen-gross-subtitle-partner')
                    : t('pension-cocktail-fill-screen-gross-subtitle')}
        >
            {!isPartnerSection && (
                <CurrencyFormGroup
                    title={{
                        label: t('pension-cocktail-fill-screen-gross-label')
                    }}
                    value={pensionInfo?.self?.employeePensionGrossYearly}
                    onChange={(cents) => {
                        actions.setParameters({
                            pensionInfo: { self: { employeePensionGrossYearly: cents } },
                        });
                    }}
                    className="mb-8"
                />
            )}
            {!!isPartnerSection && (
                <CurrencyFormGroup
                    title={{
                        label: t('pension-cocktail-fill-screen-gross-label-partner')
                    }}
                    value={pensionInfo?.partner?.employeePensionGrossYearly}
                    onChange={(cents) => {
                        actions.setParameters({
                            pensionInfo: { partner: { employeePensionGrossYearly: cents } },
                        });
                    }}
                    className="mb-8"
                />
            )}

            <div className="flex flex-row flex-wrap gap-4 items-start my-8">
                <BackButton />
                <NextButton
                    nextPage={getNextPage()}
                    isDisabled={!isValid(pensionInfo, isPartnerSection)}
                />
            </div>
            <SavingButtons/>
        </CocktailWrapperScreen>
    );
};

function isValid(parameters: PensionParameters['pensionInfo'], isPartnerSection: boolean): boolean {
    if (isPartnerSection) {
        return parameters?.partner?.employeePensionGrossYearly !== undefined;
    } else {
        return parameters?.self?.employeePensionGrossYearly !== undefined;
    }
}
